import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 列表
export const setUeBlocks: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.total = payload.total;
  state.list.loading = !!payload.loading;
};

// 详情
export const setUeBlockDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 模板列表
export const setDigitalBlockMods: Mutation<IModuleState> = (state, payload) => {
  state.blockMods.data = payload.data;
  state.blockMods.loading = !!payload.loading;
};

// 摆放轴
export const setDigitalBlockAxis: Mutation<IModuleState> = (state, payload) => {
  state.blockAxis.data = payload.data;
  state.blockAxis.loading = !!payload.loading;
};

// 模块组装类型
export const setBlockStructTypes: Mutation<IModuleState> = (state, payload) => {
  state.structTypes.data = payload.data;
  state.structTypes.loading = !!payload.loading;
};

// 控制件组装位置类型
export const setLocationTypes: Mutation<IModuleState> = (state, payload) => {
  state.locationTypes.data = payload.data;
  state.locationTypes.loading = !!payload.loading;
};

// 模块状态
export const setBlockStatusTypes: Mutation<IModuleState> = (state, payload) => {
  state.statuses.data = payload.data;
  state.statuses.loading = !!payload.loading;
};

// 缩略图
export const setUeBlockThumb: Mutation<IModuleState> = (state, payload) => {
  state.thumb.data = payload.data;
  state.thumb.loading = payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.name = payload.name;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 设置列表搜索条件
export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
  state.searchParams = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
